/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Outbound/view.blocks to change it.
import Attachments from './Attachments/index'
import CardMessageNoAvatar from 'DesignSystem/CardMessageNoAvatar/index'
import Message from './Message/index'
import React from 'react'
import Secure from './Secure/index'
import SentTime from './SentTime/index'
import Tags from './Tags/index'
import User from './User/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Outbound({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/InApp/Content/Outbound"
  
}) {
  return (<React.Fragment
>
<CardMessageNoAvatar
  viewPath={`${viewPath}/CardMessageNoAvatar`}
 marginLeft={30}
 alignSelf="flex-end"
 backgroundColor="rgba(0,0,0,0.05)"
>
{childProps => (
<React.Fragment>
<Message
{...childProps}
  viewPath={`${viewPath}/Message`}
/>
<div
  data-testid="Outbound.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Tags
  viewPath={`${viewPath}/Tags`}
/>
<User
  viewPath={`${viewPath}/User`}
/>
<Secure
  viewPath={`${viewPath}/Secure`}
/>
<SentTime
  viewPath={`${viewPath}/SentTime`}
/>
</div>
<Attachments
{...childProps}
  viewPath={`${viewPath}/Attachments`}
/>
</React.Fragment>
)}
</CardMessageNoAvatar>
{children}
</React.Fragment>)
}